/**
 * @file 小程序支付模块
 * @author congpeisen@baidu.com
*/
/* globals swan, getApp */
/* eslint-disable */
import { getQueryObject } from './core';
import { nav } from './navigate';
export let pay = (url, redirect = true) => {
  window.location.href = url;
};